import { createActionGroup, props } from '@ngrx/store';
import { notificationsFeatureKey } from './selectors';
import { MatSnackBarConfig } from '@angular/material/snack-bar';

export const NotificationsActions = createActionGroup({
  source: notificationsFeatureKey,
  events: {
    showNotification: props<{ message: string; action?: string; config?: MatSnackBarConfig }>(),
    showNotificationComponent: props<{
      message: string;
      icon?: string;
      title?: string;
      duration?: number;
    }>(),
    showDocGenerationNotificationComponent: props<{
      icon?: string;
      title?: string;
      duration?: number;
      docName: string;
      uniqueId: string;
    }>(),
    showWorkspaceCreationNotificationComponent: props<{
      icon?: string;
      title?: string;
      duration?: number;
      uniqueId: string;
    }>(),
    showWorkspaceAddDocumentsNotificationComponent: props<{
      icon?: string;
      title?: string;
      duration?: number;
      uniqueId: string;
    }>(),
  },
});
